import { render } from "./PurchaseIneligibleModal.vue?vue&type=template&id=2347b28b&scoped=true"
import script from "./PurchaseIneligibleModal.vue?vue&type=script&lang=js"
export * from "./PurchaseIneligibleModal.vue?vue&type=script&lang=js"

import "./PurchaseIneligibleModal.vue?vue&type=style&index=0&id=2347b28b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2347b28b"]])

export default __exports__